import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from "components/ProgressBar";

import calculateCompleteness from "../utils/CompletenessCalculator";

Completeness.propTypes = {
    product: PropTypes.object
};

function Completeness({product}) {

    const validFieldsCountPercentage = calculateCompleteness(product);

    return (
        <ProgressBar percentage={validFieldsCountPercentage} />
    );
}

export default Completeness;
